import React from 'react';
import {
  Accordion,
} from "@/components/ui/accordion";
import { SidebarMenuItem } from './SidebarMenuItem';
import { MenuConfig } from './types';

interface SidebarMenuProps {
  isCollapsed: boolean;
  customConfig?: MenuConfig;
}

// Renders the resource-driven menu built by DynamicSidebar. There is no longer a
// role/pathContext fallback — the navbar is always supplied as `customConfig`.
export const SidebarMenu: React.FC<SidebarMenuProps> = ({
  isCollapsed,
  customConfig,
}) => {
  const menuConfig = customConfig ?? { items: [] };

  // For collapsed view, show only icons
  if (isCollapsed) {
    return (
      <div className="flex-1 px-2 py-3 overflow-y-auto">
        <div className="flex flex-col items-center gap-1">
          {menuConfig.items.map((item) => (
            <SidebarMenuItem
              key={item.id}
              item={item}
              isCollapsed={true}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto py-3">
      <Accordion type="single" collapsible className="w-full space-y-0.5">
        {menuConfig.items.map((item) => (
          <SidebarMenuItem
            key={item.id}
            item={item}
            isCollapsed={false}
          />
        ))}
      </Accordion>
    </div>
  );
};
